import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { logger, modalNotification, totalTimeDifference } from "utils";
import adminRouteMap from "routeControl/adminRouteMap";
import { logout, selectUserData } from "redux/AuthSlice/index.slice";
import { CommonService, UserAuthServices } from "services";
import {
  GlobalLoader,
  ImageElement,
  NoDataFound,
  SweetAlert,
} from "../UiElement";
import {
  checkValidCount,
  iconNameFormatter,
  nameFormatter,
  textFormatter,
} from "../Formatter";

function AdminHeader({ menuToggle }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const userData = useSelector(selectUserData);
  const [loading, setLoading] = useState(false);
  const [isAlertVisible, setIsAlertVisible] = useState(false);
  const [notificationList, setNotificationList] = useState([]);
  const [notificationCount, setNotificationCount] = useState(0);
  const [notificationLoading, setNotificationLoading] = useState(false);
  const [perPage] = useState(5);
  const userToken = userData?.token;
  const dispatch = useDispatch();
  const showSweetAlert = () => {
    setIsAlertVisible(true);
  };

  const getNotificationList = async () => {
    setNotificationLoading(true);
    try {
      let queryParams = { limit: perPage, offset: 0 };
      const res = await CommonService.notificationService(queryParams);
      const { data, success } = res;
      if (success) {
        setNotificationList(data?.rows);
      }
    } catch (error) {
      logger(error);
    }
    setNotificationLoading(false);
  };

  const getNotificationCount = async () => {
    try {
      const res = await CommonService.unreadNotificationCountService();
      const { data, success } = res;
      if (success) {
        setNotificationCount(data.count);
      }
    } catch (error) {
      logger(error);
    }
  };

  useEffect(() => {
    if (userToken) {
      getNotificationCount();
    }
  }, [userToken]);

  const handleRead = async () => {
    setNotificationLoading(true);
    try {
      const response = await CommonService.notificationStatusService();
      const { success } = response;
      if (success) {
        getNotificationCount();
      }
    } catch (error) {
      logger(error);
    }
    setNotificationLoading(false);
  };

  useEffect(() => {
    if (userToken) {
      // getNotificationList();
      getNotificationCount();
      const interval = setInterval(() => {
        getNotificationCount();
      }, 20000);
      return () => clearInterval(interval);
    }
  }, []);

  const accountLogout = async () => {
    try {
      const response = await UserAuthServices.userLogout();
      const { success, message } = response;
      if (success) {
        modalNotification({
          type: "success",
          message,
        });
        setLoading(false);
        setIsAlertVisible(false);
        dispatch(logout(navigate, userData?.userRole?.role?.role));
      }
    } catch (error) {
      logger(error);
    }
    setLoading(false);
  };

  const onConfirmAlert = () => {
    setLoading(true);
    accountLogout();
    return true;
  };

  return (
    <div className="nk-header nk-header-fixed is-light">
      <div className="container-fluid">
        <div className="nk-header-wrap">
          <div className="nk-menu-trigger d-xl-none ms-n1">
            <Link
              onClick={() => menuToggle()}
              to="#"
              className="nk-nav-toggle nk-quick-nav-icon ps-0"
            >
              <em className="icon ni ni-menu" />
            </Link>
          </div>
          <div className="nk-header-brand d-xl-none">
            <Link to={adminRouteMap.DASHBOARD.path} className="logo-link">
              <div className="fs-5 fw-bold">Admin</div>

              {/* <ImageElement
                className="logo-img"
                previewSource="/assets/images/admin/logo-dark.svg"
                alt="logo"
              /> */}
            </Link>
          </div>
          <div className="nk-header-tools">
            <ul className="nk-quick-nav">
              <Dropdown
                as="li"
                className="notification-dropdown"
                onToggle={(e) => {
                  if (e) {
                    getNotificationList();
                  }
                }}
              >
                <Dropdown.Toggle
                  as="a"
                  className="nk-quick-nav-icon btn-icon btn-icon-break p-0"
                >
                  <div className="badge badge-circle align-items-center bg-primary">
                    {notificationCount > 0 &&
                      checkValidCount(notificationCount)}
                  </div>
                  <em className="ni ni-bell" />
                </Dropdown.Toggle>
                <Dropdown.Menu align="end" className="dropdown-menu-xl">
                  <div className="dropdown-head">
                    <span className="sub-title nk-dropdown-title">
                      {t("text.common.notification")}
                    </span>
                    <Link
                      className="text-info"
                      to="#"
                      onClick={(e) => {
                        e.preventDefault();
                        handleRead();
                      }}
                    >
                      {t("text.common.markAsRead")}
                    </Link>
                  </div>
                  <div className="dropdown-body">
                    <div className="nk-notification">
                      {notificationLoading ? (
                        <GlobalLoader />
                      ) : notificationList.length > 0 ? (
                        notificationList.map((item) => {
                          return (
                            <>
                              <div className="nk-notification-item dropdown-inner">
                                <div className="nk-notification-icon">
                                  <em className="icon icon-circle bg-warning-dim ni ni-curve-down-right" />
                                </div>
                                <div className="nk-notification-content">
                                  <div>
                                    <div className="nk-notification-text text-break">
                                      {/* {item?.notificationData} */}
                                      {item?.message}
                                    </div>
                                    <div className="nk-notification-time">
                                      {totalTimeDifference(
                                        item?.createdAt,
                                        new Date()
                                      )}{" "}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </>
                          );
                        })
                      ) : (
                        <NoDataFound />
                      )}
                    </div>
                  </div>
                  <div className="dropdown-foot center">
                    {notificationList?.length > 0 && (
                      <Link
                        className="text-info"
                        onClick={(e) => {
                          e.preventDefault();
                          if (notificationCount > 0) {
                            handleRead();
                          }
                          navigate(adminRouteMap.NOTIFICATIONS.path);
                          document.body.click();
                        }}
                      >
                        {t("text.common.viewAll")}
                      </Link>
                    )}
                  </div>
                </Dropdown.Menu>
              </Dropdown>
              <Dropdown as="li" className="user-dropdown">
                <Dropdown.Toggle as="a" className="me-n1" id="dropdown-basic">
                  <div className="user-toggle">
                    <div className="user-avatar sm">
                      {userData?.profileImageUrl ? (
                        <ImageElement
                          previewSource={userData?.profileImageUrl}
                          className="img-fluid"
                          alt="profile"
                          origin="anonymous"
                        />
                      ) : (
                        iconNameFormatter(userData?.firstName)
                      )}
                    </div>
                    <div className="user-info d-none d-xl-block">
                      {/* <div className="user-status user-status-unverified">Unverified</div> */}
                      <div className="user-name dropdown-indicator">
                        {nameFormatter(userData?.firstName, userData?.lastName)}
                      </div>
                    </div>
                  </div>
                </Dropdown.Toggle>
                <Dropdown.Menu align="end" className="dropdown-menu-md">
                  <div className="dropdown-inner user-card-wrap bg-lighter d-none d-md-block">
                    <div className="user-card">
                      <div className="user-avatar">
                        {userData?.profileImageUrl ? (
                          <ImageElement
                            previewSource={userData?.profileImageUrl}
                            className="img-fluid"
                            alt="profile"
                            origin="anonymous"
                          />
                        ) : (
                          iconNameFormatter(userData?.firstName)
                        )}
                      </div>
                      <div className="user-info">
                        <span className="lead-text">
                          {nameFormatter(
                            userData?.firstName,
                            userData?.lastName
                          )}
                        </span>
                        <span className="sub-text">
                          {textFormatter(userData?.email)}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="dropdown-inner">
                    <ul className="link-list">
                      <li>
                        <Link
                          to={adminRouteMap.ADMIN_PROFILE.path}
                          onClick={() => {
                            document.body.click();
                          }}
                        >
                          <em className="icon ni ni-user-alt" />
                          <span>{t("text.common.viewProfile")}</span>
                        </Link>
                      </li>
                      <li>
                        <Link
                          to={adminRouteMap.ADMIN_CHANGE_PASSWORD.path}
                          onClick={() => {
                            document.body.click();
                          }}
                        >
                          <em className="icon ni ni-lock-alt-fill" />
                          <span>{t("text.adminAuth.changePassword")}</span>
                        </Link>
                      </li>
                    </ul>
                  </div>
                  <div className="dropdown-inner">
                    <ul className="link-list">
                      <li>
                        <Link
                          to="/"
                          onClick={(e) => {
                            e.preventDefault();
                            showSweetAlert();
                          }}
                        >
                          <em className="icon ni ni-signout" />
                          <span>{t("text.common.signOut")}</span>
                        </Link>
                      </li>
                    </ul>
                  </div>
                </Dropdown.Menu>
                <SweetAlert
                  reverseButtons
                  title="Logout"
                  text="Are you sure want to logout?"
                  show={isAlertVisible}
                  icon="warning"
                  showCancelButton
                  cancelButtonText="No"
                  confirmButtonText="Yes"
                  setIsAlertVisible={setIsAlertVisible}
                  showLoaderOnConfirm
                  loading={loading}
                  onConfirmAlert={onConfirmAlert}
                />
              </Dropdown>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminHeader;
